import { render, staticRenderFns } from "./AddActivitySuccess.vue?vue&type=template&id=fc02b296&scoped=true"
import script from "./AddActivitySuccess.vue?vue&type=script&lang=js"
export * from "./AddActivitySuccess.vue?vue&type=script&lang=js"
import style0 from "./AddActivitySuccess.vue?vue&type=style&index=0&id=fc02b296&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc02b296",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc02b296')) {
      api.createRecord('fc02b296', component.options)
    } else {
      api.reload('fc02b296', component.options)
    }
    module.hot.accept("./AddActivitySuccess.vue?vue&type=template&id=fc02b296&scoped=true", function () {
      api.rerender('fc02b296', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/marketing/activity/addactivity/AddActivitySuccess.vue"
export default component.exports